import LithiumV2Settings from '@/modules/integrations/types/lithiumv2/LithiumV2Settings'
import LithiumV2Overview from '@/modules/integrations/types/lithiumv2/LithiumV2Overview'
import LithiumV2Promotions from '@/modules/integrations/types/lithiumv2/LithiumV2Promotions'
import LithiumV2SyncDialog from '@/modules/integrations/types/lithiumv2/LithiumV2SyncDialog'

export default Object.freeze({
  type: 'lithiumv2',
  title: 'Integrations_Lithium_V2',
  category: 'Integrations_Lithium_Category',
  description: 'Integrations_Lithium_Description',
  image: require('@/img/integrations/lithium.png'),
  requiresAdmin: false,
  components: {
    settings: LithiumV2Settings,
    overview: LithiumV2Overview,
    promotions: LithiumV2Promotions
  },
  actions: [
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_Lithium_Action_Sync',
      dialog: LithiumV2SyncDialog
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/third-party-integrations'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/lithiumv2/index.js